import React, { useEffect, useState } from "react";
import LeagueInfo from "./LeagueInfo";
import "./LeagueStyles.scss";
import LeaguesDropdown, {
  LeagueDescription,
  initLeagueDescription,
} from "../components/LeaguesDropdown";
import { getAllLeagues } from "../../services/leagueService";
import { League } from "../../types/League";

interface SearchLeaguePanelProps {}

const SearchLeaguePanel: React.FC<SearchLeaguePanelProps> = () => {
  const [leaguesLabels, setLeaguesLabels] = useState([initLeagueDescription]);
  const [currentLeagueDescription, setCurrentLeagueDescription] =
    useState<LeagueDescription>(initLeagueDescription);
  const [currentLeague, setCurrentLeague] = useState<League | undefined>(
    undefined
  );
  const [allLeagues, setAllLeagues] = useState<League[]>([]);
  useEffect(() => {
    getAllLeagues().then((data) => {
      const currLeague = data.filter(
        (item: League) => item.name === "General"
      )[0];
      setLeaguesLabels(
        data.map((item: League) => ({
          label: item.name,
          leagueId: item.id,
        }))
      );
      setCurrentLeague(currLeague);
      setAllLeagues(data);
      setCurrentLeagueDescription({
        label: currLeague.name,
        leagueId: currLeague.id,
      });
    });
  }, []);

  useEffect(() => {
    setCurrentLeague(
      allLeagues.filter(
        (league: League) => league.id === currentLeagueDescription.leagueId
      )[0]
    );
  }, [allLeagues, currentLeagueDescription]);
  return (
    <div className="searchLeaguePanel__root">
      <LeaguesDropdown
        setCurrentLeague={setCurrentLeagueDescription}
        leagueOptions={leaguesLabels}
        width="90%"
        currentLeague={currentLeague?.name}
      />
      <LeagueInfo currentLeague={currentLeague} height="400px"/>
    </div>
  );
};

export default SearchLeaguePanel;

export { getAllLeagues };
